import { cn } from "cy-fe/src/utils/cn";

export function LoadingSpinner({
  className,
  "data-testid": dataTestId,
}: {
  className?: string;
  "data-testid"?: string;
}) {
  const baseTestId = dataTestId || "loading-spinner";
  return (
    <div
      data-testid={baseTestId}
      className={cn(
        "h-20 w-20 animate-spin rounded-full",
        "border-[10px] border-gray-300",
        className,
      )}
      style={{ borderTopColor: "var(--color-primary-500)" }}
    />
  );
}
